export default "__VITE_PUBLIC_ASSET__66ffd6ef__"